/** Shared easing for signup motion: a strong ease-out for entering elements. */
export const easeOut = [0.16, 1, 0.3, 1] as const;

/** Tailwind form of `easeOut` for CSS transitions. */
export const easeOutClass = 'ease-[cubic-bezier(0.23,1,0.32,1)]';

/** Portal radius plus press feedback on every signup button. */
export const buttonClass = `h-8 rounded-md transition-[background-color,transform] duration-150 active:scale-[0.97] ${easeOutClass}`;
